var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTinkoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1217.4 406.6",
    style: {
      enableBackground: "new 0 0 1217.4 406.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFDD2D;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#333333;}\r\n\t.st3{fill:#333333;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1175.7,406.6H41.7c-23,0-41.7-18.7-41.7-41.7L0,41.7C0,18.7,18.7,0,41.7,0l1134,0c23,0,41.7,18.7,41.7,41.7 v323.2C1217.4,387.9,1198.7,406.6,1175.7,406.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.1,107.7h208.5v104.9c0,26.9-14.3,51.7-37.6,65.2l-66.6,38.5l-66.6-38.5c-23.3-13.4-37.6-38.3-37.6-65.2 V107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.3,162.9v32.6c4.5-5,12.6-8.4,21.8-8.4h10.1V225c0,10.1-2.7,18.9-6.8,23.8h43.8 c-4.1-4.9-6.8-13.7-6.8-23.8v-37.9h10.1c9.3,0,17.4,3.4,21.8,8.4v-32.6H182.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1074.9,162.9v21.8h-60.6v15.1h56.8v18.9h-56.8v29.9h-26.1v-85.8H1074.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M976.5,162.9v21.8h-60.6v15.1h56.8v18.9h-56.8v29.9h-26.1v-85.8H976.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M821.2,160.6c35,0,56.1,19.8,56.1,45.4c0,25.6-21.1,45.4-56.1,45.4c-35.2,0-56.3-19.8-56.3-45.4 C765,180.4,786.1,160.6,821.2,160.6z M821.2,230.5c17.3,0,28.7-10.5,28.7-24.5c0-14.1-11.4-24.3-28.7-24.3 c-17.5,0-28.7,10.3-28.7,24.3C792.6,220.1,803.7,230.5,821.2,230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M701.4,216.3h-7.2v32.5h-26.1v-85.8h26.1v32.3h7.2l31.6-32.3h32.8L724,204l43.5,44.7h-34.8L701.4,216.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M553.9,162.9h24.2l45.3,47.1v-47.1h24.9v85.8h-23.1l-46.3-47.4v47.4h-24.9V162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.1,162.9v85.8h-27.1v-85.8H534.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.1,248.8h-27.1v-62.9h-37.2v-22.9h101.4v22.9h-37.1V248.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinkoff);
export default __webpack_public_path__ + "static/media/tinkoff.6f15ecd11ada82be46fbd51e72a565ed.svg";
export { ForwardRef as ReactComponent };